module.exports = __webpack_public_path__ + "img/3.0be5b31a.jpg";